// extracted by mini-css-extract-plugin
export default {"RequestNewPasswordPage":"styles_RequestNewPasswordPage__Lmr3y","container":"styles_container__WQ0HZ"};